module.exports = __webpack_public_path__ + "static/media/obxWhite@2x.8574f78a.png";